require("intersection-observer");
require("url-search-params-polyfill");
require("whatwg-fetch");

require("./src/styles/tailwind.css");

exports.shouldUpdateScroll = ({ prevRouterProps }) => {
  // When the `<ScrollHandler>` component is first loaded `prevRouterProps` is
  // `null`. When navigating within the site using Gatsby's `<Link>` component
  // this will contain the previous page.
  //
  // For external links we want to want to side step Gatsby's "scroll
  // restoration" feature and use the browsers default behaviour.
  //
  // Unfortunately this means anchor links _will not_ work in _development_.
  // This is because in developement Gatsby lazily renders pages, meaning the
  // anchor isn't present on the page when it loads, so there's nothing for the
  // browser to scroll to.
  const isInternalLink = !!prevRouterProps;
  return isInternalLink;
};
